import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-succeed",
  "use": "icon-succeed-usage",
  "viewBox": "0 0 69.533 69.533",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 69.533 69.533\" id=\"icon-succeed\"><defs><style>#icon-succeed .a{fill:#1abb0e;}</style></defs><path class=\"a\" d=\"M120.1,85.333A34.767,34.767,0,1,1,85.333,120.1,34.767,34.767,0,0,1,120.1,85.333Zm14.88,24.23a2.608,2.608,0,0,0-3.688,0l-15.517,15.541-6.872-6.844a2.607,2.607,0,1,0-3.68,3.695l8.718,8.682a2.607,2.607,0,0,0,3.685-.005l17.357-17.383a2.607,2.607,0,0,0,0-3.688Z\" transform=\"translate(-85.333 -85.333)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol